/** The orientation selected from server-derived membership affordances. */
export type OnboardingArchetype = "organiser" | "helper" | "viewOnly";

export interface OnboardingMembershipView {
  readonly canAddToPlan: boolean;
  readonly canRecordAvailability: boolean;
  readonly canVolunteer: boolean;
}

/**
 * Choose teaching, never authority.
 *
 * These booleans are the server's answers from the current Membership. The result
 * changes words and a destination only; every destination and write independently
 * enforces its capability. No route segment, token role or browser-authored value is
 * consulted (AUT-007).
 */
export function onboardingArchetype(view: OnboardingMembershipView): OnboardingArchetype {
  if (view.canAddToPlan) return "organiser";
  if (view.canRecordAvailability || view.canVolunteer) return "helper";
  return "viewOnly";
}

export const ONBOARDING_STORAGE_PREFIX = "herefor.onboarding.complete";

export function onboardingStorageKey(publicPlanRef: string, viewerPersonId: string): string {
  return `${ONBOARDING_STORAGE_PREFIX}:${publicPlanRef}:${viewerPersonId}`;
}

export function onboardingWasCompleted(storage: Storage | undefined, key: string): boolean {
  try {
    return storage?.getItem(key) === "yes";
  } catch {
    return false;
  }
}

export function rememberOnboardingCompletion(storage: Storage | undefined, key: string): void {
  try {
    storage?.setItem(key, "yes");
  } catch {
    // Storage can be unavailable on a locked-down browser. Replaying the brief
    // orientation is safer than treating a failed write as completion.
  }
}
